import styled, { css } from "styled-components/macro";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  border-radius: 8px;
`;

export const Field = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  border-radius: 8px;
  border: 1px solid var(--Neutral-8);
  transition: all 0.2s ease-in-out;
  position: relative;
  padding: 8px;

  .field-wrapper {
    flex-wrap: wrap; /*allows multiple rows */
    gap: 6px;
    display: flex;
    width: fit-content;

    svg {
      width: 14px;
      height: 14px;
    }
  }

  ${(props) =>
    props.size === "S" &&
    css`
      ${"" /* height: 32px; */}
      font-size: 14px;
      padding: 8px;
    `}

  ${(props) =>
    props.size === "M" &&
    css`
      ${"" /* height: 40px; */}
      font-size: 16px;
      padding: 10px;
    `}
  
       ${(props) =>
    !props.disabled &&
    css`
      &:focus-within {
        border: 1px solid var(--Neutral-80);
      }
    `}
  
       /* Disabled styles */
    ${(props) =>
    props.disabled &&
    css`
      background: var(
        --Neutral-4,
        linear-gradient(
          0deg,
          rgba(31, 31, 31, 0.04) 0%,
          rgba(31, 31, 31, 0.04) 100%
        ),
        #fff
      );
      cursor: not-allowed;
    `}
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: var(--Neutral-100);
  font-weight: 400;

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &::placeholder {
    color: var(--Neutral-40);
  }

  ${(props) =>
    props.size === "S" &&
    css`
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.012px;
    `}

  ${(props) =>
    props.size === "M" &&
    css`
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.014px;
    `}
`;

export const Chip = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  flex-shrink: 0;
  padding: 0 4px;
  align-items: center;
  border-radius: 4px;
  background: var(
    --Neutral-8,
    linear-gradient(
      0deg,
      rgba(31, 31, 31, 0.08) 0%,
      rgba(31, 31, 31, 0.08) 100%
    ),
    #fff
  );

  h5 {
    ${
      "" /* overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    max-width: 70px;
    white-space: nowrap; */
    }
    color: var(--Neutral-100);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.014px;
  }

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
`;

export const Dropdown = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: 4px;
  border: 1px solid var(--Neutral-8);
  border-radius: 8px;
  background: #fff;
  list-style: none;
  padding: 4px;
  z-index: 9;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 8px;
  background: #fff;
  box-shadow:
    0 110px 31px 0 color(display-p3 0 0 0 / 0),
    0 70px 28px 0 color(display-p3 0 0 0 / 0.01),
    0 40px 24px 0 color(display-p3 0 0 0 / 0.05),
    0 18px 18px 0 color(display-p3 0 0 0 / 0.09),
    0 4px 10px 0 color(display-p3 0 0 0 / 0.1);
  color: var(--Neutral-100);
  font-weight: 400;

  /* custom scrollbar */
  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: var(--Neutral-300);
    border: 1px solid transparent;
    background-clip: content-box;
  }

  ${(props) =>
    props.size === "S"
      ? css`
          font-size: 12px;
          line-height: 16px;
          letter-spacing: -0.012px;
        `
      : css`
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.014px;
        `}
`;

export const Option = styled.li`
  padding: 8px 12px;
  cursor: pointer;
  color: var(--Neutral-100);
  font-weight: 400;

  &.toggle_label {
    color: var(--Neutral-100);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.014px;
    opacity: 0.4;
    cursor: auto;
  }

  &:hover {
    background: var(--Neutral-4);
  }

  ${(props) =>
    props.size === "S"
      ? css`
          font-size: 12px;
          line-height: 16px;
          letter-spacing: -0.012px;
        `
      : css`
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.014px;
        `}

  ${({ selected, isMulti }) =>
    selected &&
    !isMulti &&
    `
      background: #f0f0f0;
    `}

     /* Custom checkbox style for Select component */
  &.select-checkbox input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #ccc;
    border-radius: 3px;
    background-color: transparent;
    position: relative;
    cursor: pointer;
    transition: all 0.2s ease;

    &.disabled-checkbox {
      opacity: 0.5;
    }
  }

  &.select-checkbox input[type="checkbox"]:checked {
    background-color: #1f1f1f;
  }

  &.select-checkbox input[type="checkbox"]:focus {
    outline: none;
    box-shadow: none;
  }

  /* Optional checkmark */
  &.select-checkbox input[type="checkbox"]:checked::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 5px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;
